module.exports = __webpack_public_path__ + "static/media/close.704118bd.svg";